import {useState} from "react";
import {Form, Alert, Button} from "react-bootstrap";
import {restApiBase} from "../settings";




export function Auth(props) {
    const [showAuthWarning, setShowAuthWarning] = useState(false);

    const [fieldName, updateFieldName] = useState('');
    const [fieldMail, updateFieldMail] = useState('');

    const [processingState, setProcessingState] = useState(false);

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };


    function handleAuth() {

        setProcessingState(true);

        const url = restApiBase+"user_auth";
        const data = {
            user_name : fieldName,
            user_email : fieldMail
        };

        console.log("url:"+url);
        console.dir(data);
        console.log(JSON.stringify(data));
        

        fetch(url, {
            method: "POST",
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(data)
        })
        .then(response => {
            setProcessingState(false);

            return response.text();  // Use text() first to see the raw response
        })
        .then(text => {
            try {
                const data = JSON.parse(text);  // Parse the text as JSON
                return data;
            } catch (err) {
                console.error('Could not parse JSON:', text);
            }
        })
        .then(result => {
           console.dir(result);
           if(result.error) {
               setShowAuthWarning(result.error+": "+result.error_description);
           } else {
               props.onAuth(result.token,result.user_id,fieldName,fieldMail)
           }
        })
        .catch(error => {
            console.dir(error);
            setProcessingState(false);
            setShowAuthWarning("Server request error: " + error.message);
        });

    }


    return (
        <div className="full-screen">
            <Form className="col-12 col-md-6">
                <h3 className="mb-5">Log In</h3>
                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Name</Form.Label>
                    <Form.Control type="text"
                                  placeholder="Name"
                                  value={fieldName}
                                  className="px-0"
                                  onChange={(e)=>{
                                      updateFieldName(e.target.value);
                                  }}
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Email</Form.Label>
                    <Form.Control type="email" placeholder="name@example.com"
                                  isInvalid={(fieldMail.length > 0) && !validateEmail(fieldMail)}
                                  isValid={(fieldMail.length > 0) && validateEmail(fieldMail)}
                                  value={fieldMail}
                                  className="px-0"
                                  onChange={(e)=>{
                                      setShowAuthWarning(false);
                                      updateFieldMail(e.target.value);
                                  }}
                    />
                </Form.Group>
                {(showAuthWarning !== false) &&
                <Alert variant="danger" onClose={() => setShowAuthWarning(false)} dismissible>

                    <p>{showAuthWarning}
                    </p>
                </Alert>
                }
                <Button variant="primary" className="my-4" onClick={() =>
                        {
                            if(validateEmail(fieldMail)) {
                                setShowAuthWarning(false);
                                handleAuth();
                            } else {
                                setShowAuthWarning("Please enter valid Name and Email!");
                            }
                        }
                    }

                >
                    {processingState ? 'Processing...' : 'Continue'}
                </Button>
            </Form>
        </div>
    )
}